import { Pipe, PipeTransform } from '@angular/core';

/**
 * Takes an array of invite permissions that have had the customer
 * attached (see getInvitesWithCustomers).
 *
 * Returns true if all customer permissions have enabled customers.
 * Returns false if any customer permission has a disabled customer.
 *
 * Non-customer permissions are treated as valid.
 */
@Pipe({
    name: 'invitePermissionsAreValid',
    pure: true,
    standalone: false
})
export class InvitePermissionsAreValidPipe implements PipeTransform {
  transform(permissions: Array<any>): boolean {
    return (
      permissions?.reduce((accum, current) => accum && (current.customer?.enabled ?? true), true) ??
      true
    );
  }
}
